



























import { Component, Vue, Prop, Provide, Inject } from 'vue-property-decorator'
import Menu from './patials/Menu.vue'
import NavbarDropdownMenu from './patials/NavbarDropdownMenu.vue'
import DrawerMenu from './patials/DrawerMenu.vue'

@Component({
  components: { Menu, NavbarDropdownMenu, DrawerMenu },
})
export default class Navbar extends Vue {
  isOpenSidebar = false
  @Prop()
  logo!: string

  @Inject('is-observer')
  readOnly!: () => boolean

  @Provide('close-mobile-sidebar')
  toggleMenu() {
    this.isOpenSidebar = !this.isOpenSidebar
  }
}
